module.exports = __webpack_public_path__ + "static/media/handshake.346d077f.png";